module.exports = __webpack_public_path__ + "static/img/first@2x.8f72ab7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xiazia/first@2x.png
// module id = Vsvk
// module chunks = 0